<h2 mat-dialog-title style="color: #FFF; font-family: Inter;">
  <mat-icon color="warn">warning</mat-icon> {{ data.title }}
</h2>
<div mat-dialog-content style="color: #FFF;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;">
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions style="justify-content: right;">
  <button mat-button (click)="onNoClick()" style="font-family: Inter; background-color: #89B4F8;">Aceptar</button>
</div>